module.exports = __webpack_public_path__ + "static/media/encanador.be72908e.jpg";